export const openApp = (token, appName, appUrl, External, navigate) => {
  console.log("opemAPpp", appName, appUrl);
  if (!token) {
    navigate("/");
  }

  window.open(`${appUrl}?external=${!External}`, "_blank");
};
